import RoleButtonLink from 'components/RoleButtonLink';
import React from 'react';
import { ADMIN } from 'components/RoleGate/constants';
import { NEW_ORGANIZATION_MODAL } from '../..';

export default function NewOrganizationLinkButton(): React.ReactElement {
    return (
        <RoleButtonLink
            buttonProps={{
                primary: true
            }}
            params={{
                [NEW_ORGANIZATION_MODAL]: true
            }}
            requiredRoles={[ADMIN]}
        >
            + New Organization
        </RoleButtonLink>
    );
}
